import React, { useContext } from 'react'
import { useField } from 'formik'

import { Switch, styled, SwitchProps, useThemeName } from 'tamagui'

import { FormFieldContext } from './shared'

export const FormSwitch = (props: SwitchProps) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, _meta, helpers] = useField(formFieldContext.name)
  const isChecked = !!field.value

  // Subscribe to theme changes — Tamagui Switch uses disableTheme internally,
  // so without this the backgroundColor tokens don't re-resolve on theme switch
  useThemeName()

  return (
    <StyledSwitch
      {...props}
      animation='fastSpring'
      size='$11'
      checked={isChecked}
      backgroundColor={isChecked ? '$primaryColor' : '$borderColor'}
      borderColor={isChecked ? '$primaryColor' : '$borderColor'}
      onCheckedChange={(checked: boolean) => {
        helpers.setValue(checked)

        if (props.onCheckedChange) {
          props.onCheckedChange(checked)
        }
      }}
    >
      <StyledSwitchThumb size='$9' animation='fastSpring' />
    </StyledSwitch>
  )
}

const StyledSwitch = styled(Switch, {
  acceptsClassName: true,

  padding: 3,

  // outlineStyle: 'unset',
  outlineColor: '$backgroundAccentMuted',
} as const)

const StyledSwitchThumb = styled(Switch.Thumb, {
  backgroundColor: '$background',
  // @ts-expect-error boxShadow is web-only
  boxShadow: `rgba(0, 0, 0, 0.2) 0px 2px 6px`,
} as const)
